import React from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import { FormInput, FormInputWithButton, FormSelect, FormTextarea } from '../../molecules/FormField';
import ToggleField from '../../molecules/ToggleField';
import RoleMultiSelect from '../../molecules/RoleMultiSelect';
import Stepper from '../../organisms/Stepper';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import { DEMO_CATEGORY_TYPES, DEMO_ROLES } from '../../../data/settingsSteps';

export default function CategoryTypeStep({ stepMeta, stepperProps }) {
  const { state, update } = useSettingsWizard();

  return (
    <>
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />
      <SettingsCard
      title={stepMeta.title}
      description={stepMeta.description}
      showNext={false}
    >
      <div className="ca-category-type__status">
        <ToggleField
          checked={state.active}
          onChange={(active) => update({ active })}
        />
      </div>
      <div className="ca-step-section">
        <div className="ca-step-row ca-step-row--category-fields">
          <FormInput
            label="Category Name"
            className="ca-step-row__grow"
            value={state.categoryName}
            onChange={(e) => update({ categoryName: e.target.value })}
            placeholder="Enter category name"
          />

          {/* <div className="ca-step-row__grow "> */}


          <FormInputWithButton
            label="TAT Minutes"
            suffix={"minutes"}
            // className="ca-step-row__grow"
            type="number"
            min="0"
            value={state.tatMinutes}
            onChange={(e) => update({ tatMinutes: e.target.value })}
            placeholder="Enter here"
            />
            {/* </div> */}
        </div>
        <div className="ca-step-row">
          <FormSelect
            label="Select Template"
            className="ca-step-row__grow"
            value={state.template || state.categoryType}
            onChange={(e) => update({ template: e.target.value, categoryType: e.target.value })}
            options={DEMO_CATEGORY_TYPES}
            placeholder="Select template"
          />

             </div>



          <div className="ca-step-section">
        <FormTextarea
          label="Description"
          placeholder="Enter description"
          maxLength={500}
          value={state.description}
          onChange={(e) => update({ description: e.target.value })}
          rows={5}
        />
      </div>    
        <div className="ca-step-row">
          <FormSelect
            label="Select Visibility Type"
            className="ca-step-row__grow"
            value={state.visibilityType}
            onChange={(e) => update({ visibilityType: e.target.value })}
            options={[
              { value: 'public', label: 'Public' },
              { value: 'private', label: 'Private' },
              { value: 'restricted', label: 'Restricted' },
            ]}
            placeholder="Select visibility type"
          />
          <FormInput
            label={null}
            className="ca-step-row__grow ca-category-type__url-link"
            value={state.urlLink}
            onChange={(e) => update({ urlLink: e.target.value })}
            placeholder="urllink"
          />
        </div>
      </div>

     

      <div className="ca-step-section ca-step-section--last">
        <RoleMultiSelect
          label="Select Roles for Complaint Filling"
          options={DEMO_ROLES}
          value={state.roles}
          onChange={(roles) => update({ roles })}
        />
      </div>
      </SettingsCard>
    </>
  );
}
